<!-- 拣货明细 -->
<template>
  <div class="page-content">
    <c-header pageName="拣货明细"></c-header>
    <div class="pick-header flex-wrap">
      <section>拣货单号 : {{pickOrderSn}}</section>
      <section v-if="pickCarCode">拣货车 : {{pickCarCode}}</section>
    </div>
    <div class="search flex">
      <van-field v-model="searchPickCarCode" autofocus />
      <section @click="onBindPickingCar">{{pickCarCode ? '已确认拣货车' : '扫描拣货车'}}</section>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="picking-item flex" v-for="(item,index) in orderDetailList" :key="index">
        <div class="item-content">
          <section>库区 : {{item.szCode}}</section>
          <section>库位 : {{item.slCode}}</section>
          <section>拣货数量 : {{item.qty}}</section>
          <section>已拣数量 : {{item.pickQty}}</section>
          <section>SKU数量 : {{item.skuQty}}</section>
        </div>
        <div class="item-icon">
          <i class="iconfont xiangyou" @click="goPickingGoodsDetail(item)"></i>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
export default {
  data() {
    return {
      pickOrderSn: "", // 拣货单号
      pickOrderId: "", // 拣货单ID
      pickCarCode: "", // 绑定的拣货车
      searchPickCarCode: "", // 搜索的拣货车码
      currentPage: 1,
      pageSize: 30,
      loading: false,
      finished: true,
      orderDetailList: [],
      timer: null,
      status: null
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.pickOrderId = this.$route.query.pickingId;
    this.pickOrderSn = this.$route.query.pickOrderSn;
    this.pickCarCode = this.$route.query.pickCarCode;
    this.status = this.$route.query.status;
    this.getPickingDetailList();
  },
  methods: {
    // 明细列表
    getPickingDetailList() {
      let param = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        pickingOrderId: this.pickOrderId
      };
      this.$post(this.URL.getPickingGroupPage, param).then(res => {
        if (res.success) {
          this.orderDetailList = [...this.orderDetailList, ...res.data.records];
          this.finished = res.data.totalPage <= this.currentPage;
          // if (this.status !== '0') {
          //   this.verifyIsPickComplete();
          // }
          if (!res.data.records || res.data.records.length === 0) {
            this.verifyIsPickComplete();
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    //校验拣货明细是否拣货完成
     verifyIsPickComplete() {
      let param = {
        id: this.pickOrderId,
        intValue: 0
      };
      this.$post(this.URL.verifyPickingCart, param).then(res => {
        if (res.success) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$dialog
              .alert({
                title: "拣货提示",
                message: res.message})
              .then(() => {
                this.$router.push({ path: "/picking" });
              });
          }, 1000);
        }
      });
    },
    // 扫描拣货车
    onPickingScanCat() {},
    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getPickingDetailList();
      }
    },
    // 绑定拣货车
    onBindPickingCar() {
      if (null != this.pickCarCode && this.pickCarCode !== "") {
        this.$toast.fail("已经绑定拣货车");
        return;
      }
      let param = {
        id: this.pickOrderId,
        strValue: this.searchPickCarCode
      };
      this.$post(this.URL.bindPickingCart, param).then(res => {
        if (res.success) {
          this.pickCarCode = this.searchPickCarCode;
          this.$toast.success("绑定拣货车成功");
          this.getPickingDetailList()
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 拣货商品明细
    goPickingGoodsDetail(data) {
      if (!this.pickCarCode) {
        this.$toast.fail("请绑定拣货车");
        return;
      }
      this.$router.push({ path: "/pickingGoodsDetail", query: { info: data } });
    }
  }
};
</script>
<style lang='scss' scoped>
.pick-header {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  color: #444;
  section {
    display: flex;
    width: 100%;
    height: 2rem;
    align-items: center;
  }
}
.tools {
  padding: 0 1rem;
  font-size: 0.9rem;
  color: #444;
  section {
    display: inline-flex;
    height: 2rem;
    align-items: center;
    i {
      margin-right: 0.5rem;
    }
  }
  section:first-child {
    margin-right: 1rem;
  }
}
.search {
  margin: 0 1rem;
  align-items: center;
  height: 2.2rem;
  border: 1px solid #f0f0f0;
  border-radius: 0.2rem;
  .van-cell {
    display: inline-flex;
    align-items: center;
    height: 2rem;
    width: 70%;
    background-color: white;
  }
  section {
    height: 2rem;
    align-items: center;
    border-left: 1px solid #f0f0f0;
    font-size: 0.9rem;
    display: inline-flex;
    width: 30%;
    justify-content: center;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
}
.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;
  .picking-item {
    padding: 0.5rem 0;
    border-bottom: 1px dashed #eee;
    .item-content {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
      section {
        display: flex;
        width: 100%;
        line-height: 1.2rem;
        label {
          display: inline-flex;
        }
        label:first-child {
          width: 5rem;
        }
      }
    }
    .item-icon {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: flex-end;
      i {
        font-size: 1.5rem;
        color: #dc6350;
      }
    }
  }
  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PickingDetail.vue